// /**
//  * Authentication manager for handling login/logout and session preservation
//  */
// export const authManager = {
//   /**
//    * Set user as logged in
//    * @param {Object} userData - User data to store
//    * @param {string} token - Authentication token
//    */
//   login: (userData, token) => {
//     // Store auth data but don't change app status (to prevent logout on refresh)
//     localStorage.setItem('token', token);
//     localStorage.setItem('logged_user_id', userData.id || '');
//     localStorage.setItem('role', userData.role || '');
    
//     // Store user data as JSON string
//     if (userData) {
//       localStorage.setItem('user_data', JSON.stringify(userData));
//     }
    
//     // Set authenticated flag
//     localStorage.setItem('isAuthenticated', 'true');
//   },
  
//   /**
//    * Log user out and clear relevant storage
//    */
//   logout: () => {
//     // Save items we want to preserve
//     const buildVersion = localStorage.getItem('buildVersion');
    
//     // Clear storage
//     localStorage.clear();
//     sessionStorage.clear();
    
//     // Restore preserved items
//     if (buildVersion) {
//       localStorage.setItem('buildVersion', buildVersion);
//     }
    
//     // Set authenticated flag to false
//     localStorage.setItem('isAuthenticated', 'false');
//   },
  
//   /**
//    * Check if user is logged in
//    * @returns {boolean}
//    */
//   isLoggedIn: () => {
//     return localStorage.getItem('isAuthenticated') === 'true' && 
//            localStorage.getItem('token') !== null;
//   },
  
//   /**
//    * Get current user role
//    * @returns {string|null}
//    */
//   getRole: () => {
//     return localStorage.getItem('role');
//   },
  
//   /**
//    * Get user data
//    * @returns {Object|null}
//    */
//   getUserData: () => {
//     const userData = localStorage.getItem('user_data');
//     if (userData) {
//       try {
//         return JSON.parse(userData);
//       } catch (e) {
//         console.error('Error parsing user data:', e);
//         return null;
//       }
//     }
//     return null;
//   },
  
//   /**
//    * Get authentication token
//    * @returns {string|null}
//    */
//   getToken: () => {
//     return localStorage.getItem('token');
//   }
// }; 



export const authManager = {
  login: (userData, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('logged_user_id', userData.id || '');
    localStorage.setItem('role', userData.role || '');

    if (userData) {
      localStorage.setItem('user_data', JSON.stringify(userData));
    }

    localStorage.setItem('isAuthenticated', 'true');
  },

  logout: () => {
    // ❌ DO NOT clear everything
    // localStorage.clear();

    // ✅ Remove ONLY auth keys
    localStorage.removeItem('token');
    localStorage.removeItem('logged_user_id');
    localStorage.removeItem('role');
    localStorage.removeItem('user_data');

    localStorage.setItem('isAuthenticated', 'false');
  },

  isLoggedIn: () => {
    return (
      localStorage.getItem('isAuthenticated') === 'true' &&
      localStorage.getItem('token')
    );
  },

  getRole: () => {
    return localStorage.getItem('role');
  },

  getUserData: () => {
    const userData = localStorage.getItem('user_data');
    if (userData) {
      try {
        return JSON.parse(userData);
      } catch {
        return null;
      }
    }
    return null;
  },

  getToken: () => {
    return localStorage.getItem('token');
  },
};